module.exports = __webpack_public_path__ + "img/B2B_Tipprunde_Wm_26.c9d0cdd9.png";